export const categories = [
  { category: 'Breakfast', segments: ['Kettle'] },
  { category: 'Cooking', segments: [] },
  { category: 'Food Preparation', segments: [] },
  { category: 'Dessert', segments: [] },
  { category: 'Cookware', segments: [] },
  { category: 'Utensils', segments: [] },
  { category: 'Air Purification', segments: [] }
]

export const styles = [
  'Volume',
  'Straight',
  'Curls',
  'Waves',
  'Length',
  'Occasion'
]
